import { render } from "./CustomTagsAI.vue?vue&type=template&id=7449d870"
import script from "./CustomTagsAI.vue?vue&type=script&lang=js"
export * from "./CustomTagsAI.vue?vue&type=script&lang=js"

import "./CustomTagsAI.vue?vue&type=style&index=0&id=7449d870&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__